import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearCacheRoute,
  clearEvent,
  getCacheRoute,
  removeCacheRoute,
  watchEvent,
} from '@/store/slices/appSlice'
import { useI18n } from '@/hooks/useLocale'
import {
  IconCloseCircle,
  IconFolderDelete,
  IconFullscreen,
} from '@arco-design/web-react/icon'
import './header.less'
import { PageHeader, Tabs } from '@arco-design/web-react'
import ContexMenu from '../LoongIn/ContexMenu'
import { GlobalContext } from '@/context'
import { parseQueryString } from '@/utils/tools'
const TabPane = Tabs.TabPane

export default () => {
  const { lang } = useContext(GlobalContext)
  const cacheRoute = useSelector(getCacheRoute)
  const location = useLocation()
  const t = useI18n()
  const history = useHistory()
  const dispatch = useDispatch()
  const event = useSelector(watchEvent)
  const [contextMenuState, setContextMenuState] = useState({
    visible: false,
    top: 0,
    left: 0,
  })
  const getActiveTabKey = () => {
    const obj = cacheRoute.find(
      (c) => c.path === location?.pathname || c.key === location?.pathname
    )
    return obj ? obj.cacheKey : cacheRoute[0].cacheKey
  }
  const closeTab = (key) => {
    const idx = cacheRoute.findIndex((c) => c.cacheKey === key)
    if (idx < 0) return
    const itemFind = cacheRoute[idx]
    if (location.pathname === itemFind.path) {
      const routeitem = cacheRoute[idx - 1]
      history.push(routeitem.path)
    }
    dispatch(removeCacheRoute({ cacheKey: key }))
  }

  useEffect(() => {
    if (event) {
      if (event.name == 'history.close') {
        const key = event.params
        if (key) {
          closeTab(key)
        }
        dispatch(clearEvent())
      }
    }
  }, [event])
  const defaultContextMenu = [
    {
      Icon: <IconFullscreen />,
      title: t('b_close_current'),
      onClick: (item) => {
        closeTab(item.cacheKey)
      },
    },
    {
      Icon: <IconCloseCircle />,
      title: t('b_closeOther'),
      onClick: () => {
        const curKey = getActiveTabKey()
        if (curKey == 'dashboard/workplace') {
          dispatch(clearCacheRoute())
        } else {
          dispatch(clearCacheRoute({ cacheKey: curKey }))
        }
      },
    },
    {
      Icon: <IconFolderDelete />,
      title: t('b_close_all'),
      onClick: () => {
        const routeitem = cacheRoute[0]
        history.push(routeitem.path)
        dispatch(clearCacheRoute())
      },
    },
  ]
  const getTitle = (cache) => {
    return !lang || lang == 'zh-CN' ? cache.name : cache.nameEn
  }
  return (
    <div
      className="header-tab"
      onContextMenu={(e) => {
        e.preventDefault()
      }}
    >
      <PageHeader
        title={
          <div>
            <Tabs
              editable
              showAddButton={false}
              type="card-gutter" //"capsule" //"line" //
              activeTab={getActiveTabKey()} //当前激活tab
              onChange={(key) => {
                const idx = cacheRoute.findIndex((c) => c.cacheKey === key)
                if (idx < 0) return
                const { path, urlParams } = cacheRoute[idx]
                let pushpath
                // if (urlParams) pushpath = path + '?' + urlParams;
                if (urlParams) pushpath = path + urlParams
                else pushpath = path
                history.push(pushpath)
              }}
              onDeleteTab={(key) => {
                closeTab(key)
              }}
            >
              {cacheRoute.map((item, index) => {
                let customerTitle = ''
                if (location.pathname.includes(item.path)) {
                  if (location?.search) {
                    let params = parseQueryString()
                    if (params?.InnerNo) {
                      customerTitle = `${getTitle(item)}(${params?.InnerNo})`
                    }
                  }
                }
                return (
                  <TabPane
                    onContextMenu={(e) => {
                      e.preventDefault()
                    }}
                    style={{ fontWeight: 500, padding: '0' }}
                    closable={index > 0}
                    destroyOnHide
                    key={item.cacheKey}
                    title={
                      <div
                        style={{ display: 'flex', paddingLeft: '16px' }}
                        onContextMenu={
                          index > 0
                            ? (event) => {
                                event.preventDefault()
                                setContextMenuState({
                                  visible: true,
                                  top: event.clientY,
                                  left: event.clientX + 110,
                                  item: item,
                                })
                              }
                            : (event) => {
                                event.preventDefault()
                              }
                        }
                      >
                        <div>
                          {item.customTitle ||
                            customerTitle ||
                            getTitle(item) +
                              (item.subTitle ? `(${item.subTitle})` : '')}
                        </div>
                      </div>
                    }
                  ></TabPane>
                )
              })}
            </Tabs>
            {/* <div>
              <a onClick={() => scrollToAnchor('main-form')}>顶部</a>
              <a onClick={() => scrollToAnchor('11234')}>11234</a>
              <a onClick={() => scrollToAnchor('3456')}>3456</a>
            </div> */}
          </div>
        }
      />
      <ContexMenu
        visible={contextMenuState.visible}
        onVisibleChange={() =>
          setContextMenuState((n) => {
            return { ...n, visible: false }
          })
        }
        menu={defaultContextMenu}
        top={contextMenuState.top}
        left={contextMenuState.left}
        item={contextMenuState.item}
      />
    </div>
  )
}

